export default {
  UPDATE_LOADING_STATE: 'UPDATE_LOADING_STATE',
  UPDATE_RULES: 'UPDATE_RULES',
  UPDATE_FREQUENCIES: 'UPDATE_FREQUENCIES',
  UPDATE_TICKETS: 'UPDATE_TICKETS',
};
